import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: [
        "Frontend Architect.",
        "Scalable UI Developer.",
        "Performance-Focused Developer.",
        "Enterprise Application Developer.",
        "Modern JavaScript Developer."
      ],
      loop: true,
      typeSpeed: 20,
      deleteSpeed: 10,
      delaySpeed: 2000,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm <span className="text-designColor capitalize">Surya A</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span className="text-designColor capitalize">{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="rgb(0 252 255)"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        Results-driven Front-end Developer with 3.5+ years of experience designing and delivering scalable, responsive, and high-performance web applications across healthcare, education, and manufacturing domains. Proficient in Angular, ReactJS, and Vue.js with deep expertise in JavaScript (ES6+), TypeScript, RxJS, SCSS, and Tailwind CSS. Demonstrated ability to integrate complex REST APIs, build role-based access systems, optimize application performance, and collaborate effectively within Agile/Scrum teams. Passionate about clean code, reusable architecture, and creating seamless user experiences that drive measurable business outcomes.
        </p>
      </div>
     <Media />
    </div>
  );
}

export default LeftBanner